import { keyDidAtom, refreshLocAtom, toggleCityAtom } from "./app";
import { homeAtom } from "./home";
import rahuKaalApi from "@/api/rahuKaalApi";
import {
  assignKeyDidToParams,
  assignResolvedKeyIdForSubPageQueries,
  applyCompactHeaderToAtomAndStorage,
  buildCompactHeaderFromInfo,
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistInfoLocalStorageSubPageStyle,
  persistKeyAidFromSubPageResponseInfoKey,
  setCommonStateDataInfoOnly,
} from "./utils/weatherQueryShared";

const rahuKaalAtom = atom<any>([]);
const todayDataAtom = atom<any>({});
const queryRuhuKaalAtom = atom(null, async (get, set, newParams: any) => {
  try {
    assignResolvedKeyIdForSubPageQueries(get, newParams, homeAtom);
    const refreshloc = get(refreshLocAtom);
    const toggleCity = get(toggleCityAtom);
    clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
    assignKeyDidToParams(newParams, get(keyDidAtom));
    const resData = await rahuKaalApi.query(newParams);
    const infoData = resData?.data?.info;
    // 保持原副作用顺序：KEY_AID → commonState → INFO → header（与其它子页不同）
    persistKeyAidFromSubPageResponseInfoKey(infoData?.key);
    setCommonStateDataInfoOnly(set, infoData);
    persistInfoLocalStorageSubPageStyle(infoData);
    const resHeader = buildCompactHeaderFromInfo(infoData);
    applyCompactHeaderToAtomAndStorage(set, resHeader);
    const rahuKaal = resData?.data?.dayList ?? [];
    set(rahuKaalAtom, rahuKaal);
    set(todayDataAtom, rahuKaal?.find?.((item: any) => item.Week === "Today") ?? {});
    return resData;
  } catch (error) {
    console.error("查询每日数据失败：", error);
    throw error;
  }
});

export { rahuKaalAtom, todayDataAtom, queryRuhuKaalAtom };
